export type DecisionIconCategory = 'object' | 'relic' | 'event' | 'recovery' | 'contract' | 'decision'

export interface DecisionIconDescriptor {
  icon: string
  category: DecisionIconCategory
}

const ICONS: Record<string, DecisionIconDescriptor> = {
  'reward-remate-colocado': { icon: 'mdi:target', category: 'object' },
  'reward-pase-entre-lineas': { icon: 'mdi:vector-polyline', category: 'object' },
  'reward-presion-coordinada': { icon: 'mdi:account-group', category: 'object' },
  'reward-botas-ligeras': { icon: 'mdi:shoe-cleat', category: 'relic' },
  'reward-brazalete': { icon: 'mdi:shield-star-outline', category: 'relic' },
  'reward-balon-parado': { icon: 'mdi:soccer', category: 'object' },
  'reward-gel-energetico': { icon: 'mdi:lightning-bolt', category: 'object' },
  'reward-charla-capitan': { icon: 'mdi:bullhorn-outline', category: 'object' },
  'reward-vendaje-compresivo': { icon: 'mdi:bandage', category: 'object' },
  'reward-pulsera-biometrica': { icon: 'mdi:watch-variant', category: 'relic' },
  'reward-segundo-pulmon': { icon: 'mdi:lungs', category: 'relic' },
  'reward-lider-silencioso': { icon: 'mdi:account-voice-off', category: 'relic' },
  'reward-camilla-portatil': { icon: 'mdi:bed-empty', category: 'relic' },
  'reward-plan-personalizado': { icon: 'mdi:clipboard-check-outline', category: 'relic' },
  'reward-foto-cantera': { icon: 'mdi:image-frame', category: 'relic' },
  'reward-rodilleras-antiguas': { icon: 'mdi:shield-half-full', category: 'relic' },
  'reward-partido-a-partido': { icon: 'mdi:calendar-check-outline', category: 'relic' },
  'reward-recorte-periodico': { icon: 'mdi:newspaper-variant-outline', category: 'relic' },
  'reward-ritual-vestuario': { icon: 'mdi:handshake-outline', category: 'relic' },

  'event-training-extra': { icon: 'mdi:dumbbell', category: 'event' },
  'event-training-rest': { icon: 'mdi:bed-outline', category: 'recovery' },
  'event-coach-demand': { icon: 'mdi:account-tie-voice', category: 'event' },
  'event-coach-accept': { icon: 'mdi:account-check-outline', category: 'event' },
  'event-injury-stop': { icon: 'mdi:hospital-box-outline', category: 'recovery' },
  'event-injury-push': { icon: 'mdi:run-fast', category: 'event' },
  'event-press-speak': { icon: 'mdi:microphone-outline', category: 'event' },
  'event-press-focus': { icon: 'mdi:strategy', category: 'event' },
  'event-academy-mentor': { icon: 'mdi:school-outline', category: 'event' },
  'event-academy-drill': { icon: 'mdi:human-male-board', category: 'event' },
  'event-conditioning-load': { icon: 'mdi:weight-lifter', category: 'event' },
  'event-conditioning-biometric': { icon: 'mdi:chart-timeline-variant', category: 'event' },
  'event-conditioning-recover': { icon: 'mdi:meditation', category: 'recovery' },
  'event-locker-mediate': { icon: 'mdi:account-switch-outline', category: 'event' },
  'event-locker-bracelet': { icon: 'mdi:shield-account-outline', category: 'event' },
  'event-physio-treatment': { icon: 'mdi:medical-bag', category: 'recovery' },
  'event-physio-camilla': { icon: 'mdi:bed-clock', category: 'recovery' },

  'rest-recovery': { icon: 'mdi:heart-pulse', category: 'recovery' },
  'rest-team': { icon: 'mdi:account-group-outline', category: 'recovery' },
  'event-training': { icon: 'mdi:timer-sand', category: 'event' },
  'event-press': { icon: 'mdi:account-star-outline', category: 'event' },
  'event-coach': { icon: 'mdi:flag-outline', category: 'decision' },
  'contract-stay': { icon: 'mdi:home-heart', category: 'contract' },
  'contract-transfer': { icon: 'mdi:swap-horizontal-bold', category: 'contract' },
}

export const categoryStamp: Record<DecisionIconCategory, string> = {
  object: 'mdi:cards-outline',
  relic: 'mdi:diamond-stone',
  event: 'mdi:flash-outline',
  recovery: 'mdi:heart-plus-outline',
  contract: 'mdi:file-sign',
  decision: 'mdi:checkbox-marked-circle-outline',
}

export function decisionIconDescriptor(art: string): DecisionIconDescriptor {
  return ICONS[art] ?? { icon: 'mdi:soccer', category: 'decision' }
}

export const customDecisionIconKeys = Object.keys(ICONS)
